/*
 *
 * ResetPassword actions
 *
 */

import {
  FLUSH_STATE_RESETPASSWORD,
  LOAD_RESETPASSWORD,
  LOAD_RESETPASSWORD_SUCCESS,
  LOAD_RESETPASSWORD_ERROR,
  CHANGE_RESETPASSWORD,
  CHANGE_RESETPASSWORD_SUCCESS,
  CHANGE_RESETPASSWORD_ERROR,
  DELETE_RESETPASSWORD,
  DELETE_RESETPASSWORD_SUCCESS,
  DELETE_RESETPASSWORD_ERROR,
} from './constants';

/**
 * Clearing the state for ResetPassword
 */
export function flushStateResetPassword() {
  return {
    type: FLUSH_STATE_RESETPASSWORD,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the ResetPassword, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_RESETPASSWORD
 */
export function loadResetPassword() {
  return {
    type: LOAD_RESETPASSWORD,
  };
}

/**
 * Dispatched when the loadResetPassword are loaded by the request saga
 *
 * @param  {array} variables true for ResetPassword
 *
 * @return {array} An action object with a type of LOAD_RESETPASSWORD_SUCCESS passing the variables
 */
export function loadResetPasswordSuccess(resetPasswordList) {
  return {
    type: LOAD_RESETPASSWORD_SUCCESS,
    resetPasswordList,
  };
}

/**
 * Dispatched when loading the loadResetPassword fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_RESETPASSWORD_ERROR passing the error
 */
export function loadResetPasswordError(error) {
  return {
    type: LOAD_RESETPASSWORD_ERROR,
    error,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the ResetPassword, this action starts the request saga
 *
 * @return {array} An action object with a type of CHANGE_RESETPASSWORD
 */
export function changeResetPassword(resetPasswordData) {
  return {
    type: CHANGE_RESETPASSWORD,
    resetPasswordData,
  };
}

/**
 * Dispatched when the changeResetPassword are changed/updated by the request saga
 *
 * @param  {array} variables true for ResetPassword
 *
 * @return {array} An action object with a type of CHANGE_RESETPASSWORD_SUCCESS passing the variables
 */
export function changeResetPasswordSuccess(resetPasswordData) {
  return {
    type: CHANGE_RESETPASSWORD_SUCCESS,
    resetPasswordData,
  };
}

/**
 * Dispatched when loading the changeResetPassword fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of CHANGE_RESETPASSWORD_ERROR passing the error
 */
export function changeResetPasswordError(error) {
  return {
    type: CHANGE_RESETPASSWORD_ERROR,
    error,
  };
}

/**
 * ------------------ DELETE ------------------
 */

/**
 * Delete the ResetPassword, this action starts the request saga
 *
 * @return {object} An action object with a type of DELETE_RESETPASSWORD
 */
export function deleteResetPassword(id) {
  return {
    type: DELETE_RESETPASSWORD,
    id,
  };
}

/**
 * Dispatched when the deleteResetPassword are deleted by the request saga
 *
 * @param  {object} variables true for ResetPassword
 *
 * @return {object} An action object with a type of DELETE_RESETPASSWORD_SUCCESS passing the variables
 */
export function deleteResetPasswordSuccess() {
  return {
    type: DELETE_RESETPASSWORD_SUCCESS,
  };
}

/**
 * Dispatched when loading the deleteResetPassword fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of DELETE_RESETPASSWORD_ERROR passing the error
 */
export function deleteResetPasswordError(error) {
  return {
    type: DELETE_RESETPASSWORD_ERROR,
    error,
  };
}
